import '../less/main.less';

import LoadingDash from './components/loading-dash.vue';
import SummaryDash from './components/summary-dash.vue';
import NagiosDash from './components/nagios-dash.vue';
import DevDash from './components/dev-dash.vue';
import BlainDash from './components/blain-dash.vue';
import BlainCart from './components/blain-cart.vue';
import BlainLogistics from './components/blain-logistics.vue';

import Bugsnag from '@bugsnag/js';
import BugsnagPluginVue from '@bugsnag/plugin-vue';

Bugsnag.start({
	apiKey: '889996684f72b3c6b582ef5890ff606f',
	plugins: [new BugsnagPluginVue()]
});

const bugsnagVue = Bugsnag.getPlugin('vue');
bugsnagVue.installVueErrorHandler(Vue);

// Load jQuery (rolling eyes)
import jQuery from 'jquery';
window.jQuery = jQuery;
window.$ = jQuery;

new Vue({
	el: '#main',
	data: {
		uuid: null,
		name: null,
		dashboard: -1,
		registrationCode: null
	},
	components: {
		LoadingDash,
		SummaryDash,
		NagiosDash,
		DevDash,
		BlainDash,
		BlainCart,
		BlainLogistics
	},
	methods: {
		startWebSockets() {
			const self = this;
			const retryTimes = [0, 3000, 10000, 60000];

			window.signalRConnection = new signalR.HubConnectionBuilder().withUrl("/dphub?uuid=" + self.uuid).withAutomaticReconnect({
				nextRetryDelayInMilliseconds: context => {
					const index = context.previousRetryCount < retryTimes.length ? context.previousRetryCount : retryTimes.length - 1;
					return retryTimes[index];
				}
			}).build();
			window.signalRConnection.start().then(function () {
				console.log("SignalR connection made");
			}).catch(function (err) {
				Bugsnag.notify(err);
				return console.error(err.toString());
			});

			window.signalRConnection.on("ReceiveMessage", function (user, message) {
				console.log(`${user} says ${message}`);
			});

			window.signalRConnection.on("Refresh", function () {
				console.log("Refresh signal received");
				window.location.reload(true);
			});

			window.signalRConnection.on("Audio", function (audio) {
				console.log("Setting audio to " + audio);
				window.audio = audio;
			});

			window.signalRConnection.on("ChangeDashboard", function (dashboard) {
				console.log("Received dashboard socket message: " + dashboard);
				if (self.dashboard !== dashboard) {
					console.log("Changing dashboard to " + dashboard);
					self.dashboard = dashboard;
					window.signalRConnection.invoke("DashboardChanged", dashboard);
				} else {
					console.log("Dashboard remaining at " + dashboard);
				}
			});

			window.signalRConnection.on("Overscan", function (overscan) {
				console.log("Setting overscan compensation to " + overscan);
				if (overscan) document.body.className = "overscan";
				else document.body.className = "";

				const event = new Event('overscan', {
					bubbles: true,
					cancelable: true,
					composed: false
				})
				window.dispatchEvent(event);
			});

			window.signalRConnection.on("NagiosSummary", function (data) {
				console.log("Receiving Nagios Summary Update");

				const event = new CustomEvent("nagiosSummary", {
					detail: data,
					bubbles: true,
					cancelable: true,
					composed: false
				});
				window.dispatchEvent(event);
			});

			window.signalRConnection.on("NagiosFull", function (data) {
				console.log("Receiving Nagios Full Update");

				const event = new CustomEvent("nagiosFull", {
					detail: data,
					bubbles: true,
					cancelable: true,
					composed: false
				});
				window.dispatchEvent(event);
			});

			window.signalRConnection.on("WeatherAlert", function (data) {
				console.log("Receiving Weather Alert");

				const event = new CustomEvent("weatherAlert", {
					detail: data,
					bubbles: true,
					cancelable: true,
					composed: false
				});
				window.dispatchEvent(event);
			});
		}
	},
	mounted() {
		let self = this;
		this.$http.get('/register' + window.location.search).then(response => {
			let data = response.body;
			self.uuid = data.uuid;
			self.name = data.name;
			self.dashboard = data.dashboard;
			self.registrationCode = data.registrationCode;
			window.audio = data.audio;
			this.startWebSockets();
			if (data.overscan === 1) document.body.className = 'overscan';
			else document.body.className = "";
		}).catch(e => {
			Bugsnag.notify(new Error(e.url), function (event) {
				event.addMetadata('httpResponse', e);
			});
			console.error(e);
		});
	}
});


// WEBPACK FOOTER //
// ./src/js/main.js